import { render, staticRenderFns } from "./OptionsFilter.vue?vue&type=template&id=fbef84a2"
import script from "./OptionsFilter.vue?vue&type=script&lang=ts"
export * from "./OptionsFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports